import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_input = _resolveComponent("a-input");
  var _component_a_form_item = _resolveComponent("a-form-item");
  var _component_a_textarea = _resolveComponent("a-textarea");
  var _component_a_form = _resolveComponent("a-form");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.questionService.workProfileDialogVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.questionService.workProfileDialogVisible = $event;
    }),
    onOk: _ctx.onSubmit,
    closable: true,
    "destroy-on-close": true,
    "mask-closable": false,
    title: "作品介绍",
    "cancel-text": "关闭",
    "ok-text": "保存"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_form, {
        ref: "formRef",
        rules: _ctx.formRules,
        model: _ctx.formState,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "作品名",
            name: "title",
            required: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input, {
                size: "large",
                allowClear: "",
                maxlength: 50,
                value: _ctx.formState.title,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.formState.title = $event;
                }),
                placeholder: "请输入作品名"
              }, null, 8, ["value"])];
            }),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "作品简介",
            name: "summary",
            required: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_textarea, {
                size: "large",
                allowClear: "",
                maxlength: 400,
                showCount: "",
                value: _ctx.formState.summary,
                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.formState.summary = $event;
                }),
                placeholder: "请输入作品简介",
                rows: 5
              }, null, 8, ["value"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["rules", "model", "label-col", "wrapper-col"])];
    }),
    _: 1
  }, 8, ["visible", "onOk"]);
}